import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WidgetsComponent } from './components/widgets/widgets.component';
import { OutmodelComponent } from './components/outmodel/outmodel.component';
import { ReactiveFormsModule } from '@angular/forms';
import { FormField } from '@angular/forms/signals';
import {
    CheckboxFieldComponent,
    DateFieldComponent,
    DropdownFieldComponent,
    DurationStepperFieldComponent,
    MultilineTextFieldComponent,
    NumberFieldComponent,
    NumberStepperFieldComponent,
    RadioFieldComponent,
    RatingFieldComponent,
    TextFieldComponent,
    TimeFieldComponent,
    TreeFieldComponent,
} from '@evorait/pace-components';
import { PaceCoreModule } from '../pace-core.module';
import { WidgetsStoreModule } from '../state/widgets';

// TODO to be moved to pace-core module
@NgModule({
    declarations: [WidgetsComponent, OutmodelComponent],
    exports: [WidgetsComponent],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        PaceCoreModule.forChild(),
        // signal-forms section of the widget screen: the `[formField]` directive and
        // the store slice the form reads from and commits to
        FormField,
        DateFieldComponent,
        TimeFieldComponent,
        MultilineTextFieldComponent,
        NumberStepperFieldComponent,
        CheckboxFieldComponent,
        DurationStepperFieldComponent,
        RadioFieldComponent,
        RatingFieldComponent,
        TreeFieldComponent,
        WidgetsStoreModule,
        NumberFieldComponent,
        TextFieldComponent,
        DropdownFieldComponent,
    ],
})
export class WidgetsModule {}
